


























import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import Annoucement from "@/models/porposal/porposal.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import AnnoucementService from "@/services/porposal.service";
import { PermissionValue } from "@/enums/PermissionValue";
import { RowTable } from "@/typings/BRowTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import SendedPorposalTableComponent from '@/components/proposal-table-research-centers/table.vue';
import { ProposalState } from '@/enums/ProposalState';
import { ParesEvaluadoresTypes } from '@/enums/ParesEvaluadoresTypes.ts';
import BaseVue from '../../core/BaseVue';
import PendingProposalEvaluationsTableComponent from '@/components/proposal-pending-evaluations-table/table.vue';
import UserService from '@/services/user.service';
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import PendingEvaluationsTableComponent from "@/components/pending-evaluations-table/table.vue";

@Component({
  components : {
    PendingProposalEvaluationsTableComponent, ResearchCenterBasicInformationComponent, PendingEvaluationsTableComponent
  }
})
export default class PorposalPendingEvaluations extends BaseVue {
  userService: UserService = new UserService();
  tiposEvaluaciones: any = [];
  loading: boolean = false;

  async mounted() {
    this.loading = true;
    this.tiposEvaluaciones = await this.userService.getPendingEvaluationsByUser(this.user.id);
    this.loading = false;
  }

  get user() {
    return this.$store.state.user;
  }

}
